import app2 from '../../../images/mockups/output/1-portrait.png';

function Landing() {
  return (
    <div className="min-h-screen flex justify-center m10:h-auto bg-homeLanding bg-cover bg-no-repeat bg-left-bottom w-full overflow-x-hidden z-0">
      <div className="flex flex-row justify-between m10:justify-start w-full max-w-7xl text-primary  m10:flex m10:flex-col m10:items-center px-10 m8:px-0">
        <div className="w-8/12 flex overflow-x-hidden flex-col pt-60 m10:pt-36 justify-start m10:w-full m10:items-center">
          <div className="text-left text-4xl i1:text-3xl i2:text-3xl i3:text-4xl i4:text-4xl m6:text-3xl m10:text-center">
            Snow GMAO
          </div>
          <div className="w-full text-6xl i3:text-5xl i4:text-5xl m6:text-4xl m10:text-center pt-6 m8:pt-10">
            Un allié pour votre système d'enneigement
          </div>
          <div className="flex m8:flex-col m8:gap-4 m10:items-center mt-12 text-2xl i1:text-2xl i2:text-xl m6:text-2xl i4:text-3xl m10:justify-center m10:mb-12">
            <a href='/#contact'>
              <span className="bg-secondary text-tertiary p-2 px-6 rounded-lg mr-6 m8:ml-6 hover:translate-y-1 duration-200">
                Commençons
              </span>
            </a>
            <a href='/#more'>
              <span className="text-primary p-2 rounded-lg mr-6 m8:ml-10 hover:translate-x-1 duration-200">
                Explorez&#8239;plus&#8239;→
              </span>
            </a>
          </div>
        </div>
        <div className="w-2/5 i3:w-8/12 i4:w-10/12 m6:w-full mb-20 flex flex-col items-end m10:items-center overflow-hidden">
          <img src={app2} className="-mx-10 w-full mt-44 m10:mt-0" alt='app' />
          {/* <img src={screen11} className="-my-[10%] w-1/3 rounded-xl -translate-x-[130%] m10:-translate-x-[60%] -translate-y-[150%] hover:-translate-x-[140%] duration-200" alt='app' />
          <img src={screen12} className="-my-[10%] w-1/3 rounded-xl -translate-x-[15%] m10:translate-x-[60%] -translate-y-[250%] hover:-translate-x-[5%] duration-200" alt='app' />
          <img src={screen13} className="-my-[10%] w-1/3 rounded-xl -translate-x-[130%] m10:-translate-x-[60%] -translate-y-[350%] hover:-translate-x-[140%] duration-200" alt='app' /> */}
        </div>
      </div>
    </div>);
}

export default Landing;